import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import BreadcrumbStyle2 from '../Breadcrumb/BreadcrumbStyle2';
import Section from '../Section';
import Spacing from '../Spacing';
import BannerSectionStyle9 from '../Section/BannerSection/BannerSectionStyle9';
import { pageTitle } from '../../helpers/PageTitle';
import { BASE_URL, ASSET_URL } from '../../helpers/api';
import { prefillDoctorForBooking } from '../../helpers/doctorPrefill';

export default function DoctorDetails() {
  const { doctorId } = useParams();
  const navigate = useNavigate();
  const [doctor, setDoctor] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetch(`${BASE_URL}/doctors/${doctorId}`)
      .then((res) => res.json())
      .then((data) => setDoctor(data?.error ? null : data))
      .catch(() => setDoctor(null))
      .finally(() => setLoading(false));
  }, [doctorId]);

  pageTitle(doctor?.name || 'Doctor Details');

  const handleBookAppointment = () => {
    prefillDoctorForBooking(doctor);
    navigate('/appointments');
  };

  if (loading) {
    return (
      <div className="container" style={{ padding: '120px 0', textAlign: 'center' }}>
        Loading doctor details...
      </div>
    );
  }

  if (!doctor) {
    return (
      <div className="container" style={{ padding: '120px 0', textAlign: 'center' }}>
        Doctor not found.
      </div>
    );
  }

  const departments = doctor.departments || [];
  const departmentNames = departments.map((d) => d.department_name);

  return (
    <>
      <BreadcrumbStyle2 />
      <Section topMd={80} bottomMd={80} bottomLg={60}>
        <div className="container">
          <div className="row">
            <div className="col-lg-5">
              <div className="cs_single_doctor overflow-hidden cs_radius_20">
                <img
                  src={doctor.picture ? `${ASSET_URL}/${doctor.picture}` : '/images/doctors/doctor_details.jpeg'}
                  alt={doctor.name}
                  className="w-100"
                />
                {departmentNames.length > 0 && (
                  <h3 className="cs_white_color cs_accent_bg mb-0 text-center cs_semibold cs_fs_24">
                    {departmentNames.join(' / ')}
                  </h3>
                )}
              </div>
            </div>
            <div className="col-lg-6 offset-lg-1">
              <Spacing md="55" />
              <h2 className="cs_fs_48 mb-0 cs_semibold">{doctor.name}</h2>
              <Spacing md="12" />
              {doctor.degree && (
                <h3 className="cs_semibold cs_fs_24 mb-0">{doctor.degree}</h3>
              )}
              {doctor.specialist && (
                <p className="mb-0 cs_heading_color">{doctor.specialist}</p>
              )}
              <Spacing md="24" />
              {doctor.short_biography && (
                <p className="mb-0 cs_heading_color">{doctor.short_biography}</p>
              )}

              <Spacing md="40" />
              {doctor.has_schedule ? (
                <button className="cs_btn cs_style_1" onClick={handleBookAppointment}>
                  <span>Book Appointment</span>
                  <i>
                    <img src="/images/icons/arrow_white.svg" alt="Icon" />
                    <img src="/images/icons/arrow_white.svg" alt="Icon" />
                  </i>
                </button>
              ) : (
                <p className="cs_heading_color">
                  This doctor doesn't have any bookable schedule right now.
                </p>
              )}
            </div>
          </div>
        </div>
      </Section>

      <Section className="cs_footer_margin_0">
        <BannerSectionStyle9
          title="Don’t Let Your Health <br />Take a Backseat!"
          subTitle="Schedule an appointment with one of our experienced <br />medical professionals today!"
          imgUrl="/images/doctors/banner_img_3.png"
        />
      </Section>
    </>
  );
}
